import { type ReactNode } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';

export interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  icon?: ReactNode;
}

export function ErrorState({
  title,
  description,
  onRetry,
  retryLabel,
  icon,
}: ErrorStateProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        py: 6,
        px: 2,
      }}
    >
      {icon ?? <ErrorOutlineIcon color="error" sx={{ fontSize: 56, mb: 2 }} aria-hidden />}
      <Typography variant="h6" component="h2" gutterBottom>
        {title ?? t('components.errorState.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 480 }}>
        {description ?? t('components.errorState.description')}
      </Typography>
      {onRetry && (
        <Button variant="contained" onClick={onRetry}>
          {retryLabel ?? t('components.errorState.retry')}
        </Button>
      )}
    </Box>
  );
}
